import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import moment from 'moment';
import 'moment/locale/es';
import ChatLeft from '../../assets/logo/chat-left-fill.svg';
import ChatRight from '../../assets/logo/chat-right-fill.svg';

const CardQuestion = ({ question }) => {
  const [isHovered, setIsHovered] = useState(false);

  const fecha = moment(question.created_at).locale('es').format('DD/MM/YYYY ~ HH:mm');
  const fecha2 = moment(question.respuesta?.created_at).locale('es').format('DD/MM/YYYY ~ HH:mm');

  const handleHover = () => {
    setIsHovered(!isHovered);
  };
  return (
    <div
      className={`cardquestion-container ${isHovered ? 'cardquestion-container--hovered' : ''}`}
      onMouseEnter={handleHover}
      onMouseLeave={handleHover}
    >

      {question.respuesta
        ? (
          <>
            <div className="elements-cardquestion">
              <img src={ChatLeft} alt="Mi archivo SVG" />
              <div className="text-cardquestion">
                <h5>{question.texto}</h5>
                <h4>{fecha}</h4>
              </div>
            </div>
            <div className="elements-cardquestion">
              <img src={ChatRight} alt="Mi archivo SVG" />
              <div className="text-cardquestion">
                <h5>{question?.respuesta?.texto}</h5>
                <h4>{fecha2}</h4>
              </div>
            </div>
          </>
        )
        : (
          <div className="elements-cardquestion">
            <img src={ChatLeft} alt="Mi archivo SVG" />
            <div className="text-cardquestion">
              <h5>{question.texto}</h5>
              <h4>{fecha}</h4>
            </div>
          </div>
        )}

    </div>
  );
};

CardQuestion.propTypes = {
  question: PropTypes.string.isRequired,
};

export default CardQuestion;
